/** @jsx React.DOM */
var React = require('react/addons')
var formatters = require('../../helpers/formatters')
var constants = require('../../helpers/constants')
var AccountLink = require('./account-link')

var TransactionDescription = React.createClass({displayName: 'TransactionDescription',
  render: function() {
    var inner
    var tx = this.props.tx
    var innerTx = tx.tx

    if (this.props.perspective) {
      if (innerTx.TransactionType == 'Payment') {
        var send = innerTx.Account == this.props.perspective
        var other = send ? innerTx.Destination : innerTx.Account
          inner = React.DOM.span(null, 
            send ? 'Sent' : 'Received', ' ', 
            formatters.formatAmount(tx.meta.DeliveredAmount || innerTx.Amount), ' ', 
            send ? 'to' : ' from', ' ', 
            AccountLink({id: other}), 
            innerTx.DestinationTag ? ':' + innerTx.DestinationTag : ''

          )
        } else if (innerTx.TransactionType == 'AccountSet') {
          inner = React.DOM.span(null, "Change account settings")
        } else if (innerTx.TransactionType == 'OfferCreate') {
          inner = React.DOM.span(null, 
            "Create offer to give", ' ', 
            formatters.formatAmount(innerTx.TakerGets), 
            ' for ', 
            formatters.formatAmount(innerTx.TakerPays)
          )
        } else if (innerTx.TransactionType == 'OfferCancel') {
          inner = React.DOM.span(null, "Cancel offer with sequence #", innerTx.OfferSequence)
        } else {
          inner = React.DOM.span(null, "Unknown type: ", innerTx.TransactionType)
        }
    } else {
      throw new Error('Not implemented')
    }

    return React.DOM.span({className: "transaction-description"}, 
      inner
    )
  }
})

module.exports = TransactionDescription



//////////////////
// WEBPACK FOOTER
// ./src/partials/rmc/transaction-description.jsx
// module id = 468
// module chunks = 0